/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Task } from './task';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface TaskResult { 
    scenarioUuid: string;
    maxScore: string;
    percentage: string;
    score: string;
    order: number;
    evaluationBackgroundColor: string;
    evaluationTextColor: string;
    evaluationTitle: string;
    evaluationCode: number;
    task: Task;
}